import _ from "underscore";

export const isPhoto = (contentType?: string): boolean =>
  contentType && !_.isEmpty(contentType)
    ? contentType.indexOf("svg") === -1 && contentType.indexOf("image/") === 0
    : false;
